<template>
  <div class="signup container">
    <form class="card-panel" @submit.prevent="signup">
      <h2 class="center cyan-text text-darken-1">登録</h2>
      <h5 class="red-text center">現在メンテナンス中です</h5>
      <div class="field">
        <label for="email">Email:</label>
        <input id="email" type="email" v-model="email">
      </div>
      <div class="field">
        <label for="password">Password:</label>
        <input id="password" type="password" v-model="password">
      </div>
      <div class="field">
        <label for="alias">ニックネーム:</label>
        <input id="alias" type="text" v-model="alias">
      </div>
      <p class="red-text center" v-if="feedback">{{ feedback }}</p>
      <div class="field center">
          <button class="btn  cyan darken-1">登録する</button>
      </div>
    </form>
  </div>
</template>

<script>
import slugify from 'slugify'
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
  name: 'Signup',
  data(){
    return{
      email: null,
      password: null,
      alias: "",
      feedback: null
    }
  },
  methods:{
    signup(){
      if(this.alias && this.email && this.password){
        this.slug = slugify(this.alias, {
        replacement: '-',
        remove: /[$*_+~.()'"!\-:@]/g,
        lower: true
        })
        let ref = db.collection('users').doc(this.slug)
        ref.get().then(doc => {
          if(doc.exists){
            this.feedback = 'This alias already exists'
          } else {
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
            .then(cred =>{
              ref.set({
                alias: this.alias,
                user_id: cred.user.uid
              })
            }).then(() => {
              this.$router.push({ name: 'Home' })
            })
            .catch(err => {
              this.feedback = err.message
            })
          }
        })
      } else {
        this.feedback = "Please enter all field"
      }
    }
  }
}
</script>

<style>
.signup{
  max-width: 400px;
  margin-top: 60px;
}
.signup h2{
  font-size: 2.4em;
}
.signup .field{
  margin-bottom: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue